import { render } from "./ValidasiKewajibanTahunan.vue?vue&type=template&id=432072c2"
import script from "./ValidasiKewajibanTahunan.vue?vue&type=script&lang=js"
export * from "./ValidasiKewajibanTahunan.vue?vue&type=script&lang=js"

import exportComponent from "C:\\File Frontend Github\\aisnet\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__